import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "company-assessment-form-date" }
const _hoisted_2 = {
  key: 0,
  class: "displaymode-text"
}

import { computed } from "vue";
import type { PropType } from "vue";
import { companyAssessmentInputProps } from "./companyAssessmentInputProps";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyAssessmentFormDate',
  props: {
	modelValue: {
		type: Date as PropType<Date | null>,
		required: true,
	},
	...companyAssessmentInputProps,
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const modelValue = computed({
	get: () => props.modelValue,
	set: (value: Date | null) => emit("update:modelValue", value),
});

const dateForHumans = computed(() => {
	if (!modelValue.value) return "";
	return new Intl.DateTimeFormat("fi-FI", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	}).format(modelValue.value);
});

return (_ctx: any,_cache: any) => {
  const _component_HakoDatePicker = _resolveComponent("HakoDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.displayMode)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(dateForHumans.value), 1))
      : (_openBlock(), _createBlock(_component_HakoDatePicker, _mergeProps({
          key: 1,
          disabled: _ctx.displayMode
        }, _ctx.$attrs, {
          modelValue: modelValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
          "allow-empty": "",
          "force-utc-midnight": ""
        }), null, 16, ["disabled", "modelValue"]))
  ]))
}
}

})